import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { Support } from "../../../Component/Model/Dto/Support/SupportRequest";
import { removeHtmlAndTrim, TableDateHelper } from "../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";

interface SupportTicketRow {
    ReferenceId: string;
    Status: string;
    CreatedDate: string;
    Scorecard: string;
    CreatedBy: string;
    Description: string;
    LastFeedbackDate: string;
    LastFeedback: string;
    Actions: ActionType[];
}

interface SupportTicketTable {
    columns: Array<TableColumn>;
    rows: Array<SupportTicketRow>;
}

export function SupportTicketTableMapper(
    dataObject: Support.DtoOut[],
    handleEdit: (id: string) => void,
    handleResolve: (id: string) => void,
): SupportTicketTable {

    const columns = [
        { Header: 'Reference Id', accessor: 'ReferenceId', id: "ReferenceId", Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />, disableSortBy: true },
        { Header: 'Status', accessor: 'Status', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Date Created', accessor: 'CreatedDate', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Scorecard', accessor: 'Scorecard', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Captured By', accessor: 'CreatedBy', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Description', accessor: 'Description', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Latest Feedback Date', accessor: 'LastFeedbackDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Latest Feeback', accessor: 'LastFeedback', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: Support.DtoOut) => ({
            ReferenceId: item.ReferenceId,
            Status: item.Status,
            CreatedDate: TableDateHelper(item.CreatedDate.toString()),
            Scorecard: item.Scorecard,
            CreatedBy: item.CreatedBy,
            Description: removeHtmlAndTrim(item.Description, 30),
            LastFeedbackDate: TableDateHelper(item.LastFeedbackDate),
            LastFeedback: removeHtmlAndTrim(item.LastFeedback, 30),
            Actions: item.Status === "Resolved" ?
                [
                    { label: 'View/Edit', action: handleEdit, key: item.Id, icon: { color: 'info', name: 'edit' } },
                ]
                :
                [
                    { label: 'View/Edit', action: handleEdit, key: item.Id, icon: { color: 'info', name: 'edit' } },
                    { label: 'Resolve', action: handleResolve, key: item.Id, icon: { color: 'secondary', name: 'done_all' } }
                ]
        }));

        return { columns: columns, rows: rows };

    } else {
        return { columns: columns, rows: [] };
    }
}